const areaDefinitions = [
  {
    key: 'dataCapture',
    label: 'Data capture',
    question: 'q3',
    points: {
      'Paper, text messages or phone calls': 0,
      'An admin person types them into a spreadsheet': 8,
      'Google Forms or Cognito Forms feeding a spreadsheet': 14,
      'Dedicated timesheet or rostering software': 25
    }
  },
  {
    key: 'calculation',
    label: 'Calculation',
    question: 'q4',
    points: {
      'Manually, with Excel or Google Sheets': 0,
      'A spreadsheet with formulas': 10,
      'We re-enter the numbers into Xero or MYOB': 14,
      'It is mostly automated': 25
    }
  },
  {
    key: 'errorExposure',
    label: 'Error exposure',
    question: 'q5',
    points: {
      'Often, and we usually find out after paying or invoicing': 0,
      'I am not sure we would notice': 5,
      'Occasionally': 15,
      'Never that I know of': 25
    }
  },
  {
    key: 'visibility',
    label: 'Visibility',
    question: 'q6',
    points: {
      'I cannot see profit by client, site or job': 5,
      'Reports and invoices are hard to change': 10,
      'The spreadsheet is slow, heavy or fragile': 10,
      'Admin takes too much of my time': 15,
      'No major headaches': 25
    }
  }
];

export function getHealthReport(answers) {
  const areas = areaDefinitions.map((area) => ({
    key: area.key,
    label: area.label,
    score: area.points[answers[area.question]] ?? 0
  }));
  const score = areas.reduce((total, area) => total + area.score, 0);
  const band = score <= 40 ? 'At risk' : score <= 70 ? 'Strained' : 'Healthy';

  return { score, band, areas };
}

export function getFitSummary(answers, healthScore) {
  const segmentPoints = {
    'Labour hire or staffing': 3,
    'Logistics, warehouse or container services': 3,
    'Trade subcontractor or contractor': 3,
    'Cleaning, security or facilities': 1,
    'Other service business': 0
  };
  const teamPoints = {
    'Under 5': 0,
    '5 to 15': 3,
    '16 to 30': 3,
    'More than 30': 2
  };
  const approachPoints = {
    'Hire another admin person': 2,
    'Buy software off the shelf and adapt our process to it': 1,
    'Get a system built around how we work': 3,
    'Just exploring, no plans yet': 0,
    'Not sure yet': 2
  };
  const fitPoints =
    (segmentPoints[answers.q1] ?? 0) +
    (teamPoints[answers.q2] ?? 0) +
    (approachPoints[answers.q7] ?? 0) +
    (healthScore <= 70 ? 2 : healthScore <= 85 ? 1 : 0);
  const teamQualifies = answers.q2 !== 'Under 5';
  const approachQualifies = approachPoints[answers.q7] >= 2;
  const grade = fitPoints >= 9
    ? teamQualifies && approachQualifies ? 'A' : 'B'
    : fitPoints >= 5 ? 'B' : 'C';

  return { fitPoints, grade };
}

export function getAnnualTimeCost(answers) {
  return (Number(answers.q8) || 0) * (Number(answers.q9) || 0) * 52;
}

export function getSessionContext() {
  const params = new URLSearchParams(window.location.search);

  return {
    sessionId: window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`,
    startedAt: new Date().toISOString(),
    utmSource: params.get('utm_source') || '',
    utmMedium: params.get('utm_medium') || '',
    utmCampaign: params.get('utm_campaign') || '',
    utmContent: params.get('utm_content') || '',
    referrer: document.referrer || ''
  };
}